<template>
    <div class="app page">
        <AppNav></AppNav>
        <router-view></router-view>
        <AppFooter></AppFooter>
    </div>
</template>


<script type="text/javascript">
    export default {
        name: 'App',
        components: {
            AppNav: require('./nav').default,
            AppFooter: require('./footer').default
        }
    }
</script>


<style lang="scss">
    @import '../styles/global';
</style>
